import { Col, Modal, Row, Select, Space } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import BaseInput from '../../components/base-input';
import BaseSelect from '../../components/base-select';
import useSaveConta from '../hooks/use-save-conta';

interface ModalRepetirProps {
	isModalCadastroConta: boolean;
	setisModalCadastroConta: Dispatch<SetStateAction<boolean>>;
	fetchContas: () => void;
}

export default function ModalCadastroDeConta({ isModalCadastroConta, setisModalCadastroConta, fetchContas }: ModalRepetirProps) {
	const { conta, tipoConta, setConta, createOrPatchConta, bancos } = useSaveConta();
	const isContaValida = () => {
		return conta?.tipoConta?.id && conta?.descricao && conta?.numeroAgencia && conta?.digitoAgencia && conta?.numeroConta && conta?.digitoConta && conta?.banco;
	};
	const handleOk = async () => {
		if (!isContaValida()) return alert('Preencha todos os campos');
		await createOrPatchConta(conta);
	   fetchContas();
		setisModalCadastroConta(false);
		setConta(undefined);
	};

	const handleCancel = () => {
		setisModalCadastroConta(false);
	};

	return (
		<Modal  style={{top: '30px'}} destroyOnClose title="Cadastro de conta" visible={isModalCadastroConta} onCancel={handleCancel} onOk={handleOk} okText="Ok" cancelText="Cancelar" width={600}>
			<Space direction="vertical" style={{ width: '100%' }} size="middle">
				<Row justify="center">				
				</Row>
				<Row justify="center">
					<Col span={20}>
						<BaseSelect
						  showSearch
							value={conta?.banco?.id}
							onChange={(value) => setConta({ ...conta, banco: { ...conta?.banco, id: value } })}
							placeholder="Selecione"
							width="100%"
							labelConfig={{
								label: 'Selecione o banco',
								required: true,
								tooltip: true,
								tooltipText: 'Escolha o banco.',
							}}
							filterOption={(input, option) =>
								(option?.label ?? '').toString().toLowerCase().includes(input.toLowerCase())
							}
						>
							{bancos?.map((tipo) => (
								<Select.Option key={tipo.id} value={tipo.id} label={tipo.nome}>
									{tipo.nome}
								</Select.Option>
							))}
						</BaseSelect>
					</Col>
				</Row>
				{conta?.banco?.nome && (
					<Row justify="center">
						<Col span={20}>
							<BaseInput
								disabled
								value={conta.banco.nome}
								labelConfig={{
									label: 'Banco encontrado',
									tooltip: false,
								}}
								width="100%"
							/>
						</Col>
					</Row>
				)}
				<Row justify="center">
					<Col span={20}>
						<BaseSelect
							onChange={(value) => setConta({ ...conta, tipoConta: { ...conta?.tipoConta, id: value } })}
							placeholder="Selecione"
							width="100%"
							labelConfig={{
								label: 'Selecione o tipo de conta',
								required: true,
								tooltip: true,
								tooltipText: 'Escolha o tipo de conta: corrente, poupança ou empresarial.',
							}}
						>
							{tipoConta?.map((tipo) => (
								<Select.Option key={tipo.id} value={tipo.id}>
									{tipo.descricao}
								</Select.Option>
							))}
						</BaseSelect>
					</Col>
				</Row>

				<Row justify="center">
					<Col span={20}>
						<BaseInput
							onChange={(item) => setConta({ ...conta, descricao: item.target.value })}
							labelConfig={{
								label: 'Nome da conta',
								required: true,
								tooltip: true,
								tooltipText: 'Nome para identificar a conta bancária usada na despesa. Ex: Conta Corrente Bradesco.',
							}}
							width="100%"
							placeholder="Ex. Conta do Banco do Brasil"
							max={100}
							maxLength={100}
						/>
					</Col>
				</Row>

				<Row justify="center" gutter={16}>
					<Col span={10}>
						<BaseInput
							onChange={(item) => setConta({ ...conta, numeroAgencia: item.target.value })}
							labelConfig={{
								label: 'Número da agência',
								required: true,
								tooltip: true,
								tooltipText: 'Informe o número da agência bancária da conta.',
							}}
							width="100%"
							max={4}
							maxLength={4}
							placeholder="0000"
						/>
					</Col>
					<Col span={10}>
						<BaseInput
							onChange={(item) => setConta({ ...conta, digitoAgencia: item.target.value })}
							labelConfig={{
								label: 'Dígito da agência',
								required: true,
								tooltip: true,
								tooltipText: 'Informe o dígito verificador da agência.',
							}}
							width="100%"
							placeholder="0"
							max={1}
							maxLength={1}
						/>
					</Col>
				</Row>

				<Row justify="center" gutter={16}>
					<Col span={10}>
						<BaseInput
							onChange={(item) => setConta({ ...conta, numeroConta: item.target.value })}
							labelConfig={{
								label: 'Número da conta',
								required: true,
								tooltip: true,
								tooltipText: 'Informe o número da conta bancária.',
							}}
							max={9}
							maxLength={9}
							width="100%"
							placeholder="00000000"
						/>
					</Col>
					<Col span={10}>
						<BaseInput
							onChange={(item) => setConta({ ...conta, digitoConta: item.target.value })}
							labelConfig={{
								label: 'Dígito da conta',
								required: true,
								tooltip: true,
								tooltipText: 'Informe o digito da conta bancária.',
							}}
							width="100%"
							placeholder="0"
							max={1}
							maxLength={1}
						/>
					</Col>
				</Row>
			</Space>
		</Modal>
	);
}
